// Global overrides and additional base js goes here


class TreeAnimation extends HTMLElement {
  constructor() {
    super();
    this.leftBranchEl = this.querySelector(".left-branch");
    this.rightBranchEl = this.querySelector(".right-branch");
  }

  connectedCallback() {
    const leftBranch = this.leftBranchEl;
    const rightBranch = this.rightBranchEl;

    leftBranch.parentNode.addEventListener("mouseenter", () => {
      gsap.killTweensOf(leftBranch);
      gsap.fromTo(leftBranch,
        { rotation: 0 },
        { rotation: 5, duration: 2.5, ease: "elastic.out(1, 0.25)" }
      );
    });

    leftBranch.parentNode.addEventListener("mouseleave", () => {
      gsap.killTweensOf(leftBranch);
      gsap.to(leftBranch, { rotation: 0, duration: 0.6, ease: "sine.out" }); // smoothly return
    });


    rightBranch.parentNode.addEventListener("mouseenter", () => {
      gsap.killTweensOf(rightBranch);
      gsap.fromTo(rightBranch,
        { rotation: 0 },
        { rotation: -5, duration: 2.5, ease: "elastic.out(1, 0.25)" }
      );
    });

    rightBranch.parentNode.addEventListener("mouseleave", () => {
      gsap.killTweensOf(rightBranch);
      gsap.to(rightBranch, { rotation: 0, duration: 0.6, ease: "sine.out" }); // smoothly return
    });

  }
}

customElements.define('tree-animation', TreeAnimation);

// Click the footer logo and scroll to top
// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelector('footer .footer__image').addEventListener('click', function() {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   });
// })

const addBasket = ({ node }) => {
  if (node.querySelector('.basket-wrapper')) return; // prevent duplicates

  let newDiv = document.createElement('div');

  newDiv.classList.add('basket-wrapper');
  newDiv.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="156" height="177" viewBox="0 0 156 177" fill="none">
      <path d="M130.444 69.6716C131.245 65.2461 131.234 56.9985 123.772 51.9806C116.309 46.9628 104.417 45.166 97.578 51.0092C90.7391 56.8523 87.7208 63.0934 87.3262 68.1218C86.9316 73.1501 84.7074 69.5325 80.0737 68.3318C75.44 67.1311 69.1937 67.7406 66.7796 70.3603C66.7796 70.3603 67.175 62.3148 53.8741 59.3154C40.5732 56.316 31.515 65.7803 29.3099 72.8241C27.1048 79.8678 27.115 87.5122 27.115 87.5122C27.115 87.5122 22.2811 88.5228 21.0772 92.145C21.0772 92.145 7.57646 91.5596 2.35336 101.625C-2.86974 111.69 2.78506 124.354 9.43376 124.545C16.0825 124.737 130.444 69.6716 130.444 69.6716Z" fill="#FF580C"/>
      <path d="M92.1792 84.2075C75.3756 92.2866 39.629 108.717 26.9447 114.768C14.2604 120.819 4.29263 124.453 3.69144 126.868C3.09024 129.282 16.1094 147.67 20.6497 153.094C25.1899 158.519 43.0444 176.9 68.4296 177.168C93.8148 177.436 113.75 169.866 127.633 156.572C141.517 143.278 153.889 129.684 155.665 101.622C157.44 73.5602 151.378 59.6894 148.355 58.7882C145.331 57.8871 107.28 76.9461 92.1792 84.2075Z" fill="#C1712B"/>
      <path d="M50 3H49.5H49H48.5H48H47H46H45.5H44.8518C44.8518 3 44.053 3.025 44 3C45.8379 1.0034 48.6138 0.427051 52.9329 0.533551C64.5674 0.819651 71.9832 9.40917 78.0483 24.7884C84.1134 40.1676 91.5569 70.4798 93.8459 87.8258C96.1377 105.171 86.149 93.2671 86.149 93.2671C85.2328 86.6305 80.3595 59.4824 78.5355 49.8299C76.7087 40.1774 69.1205 14.8436 61.2537 9.12169C56.3331 5.54129 50 3 50 3Z" fill="#C1712B"/>
      <path d="M94.0007 86.7694C95.848 87.618 96.1242 92.8009 92.4978 92.8057C88.8714 92.8105 88.2642 90.6994 88.7146 88.7378C89.1655 86.7758 92.035 85.8669 94.0007 86.7694Z" fill="#905224"/>
      <path d="M138.7 72.529C140.474 75.0818 126.932 85.9713 124.055 81.7511C121.179 77.5309 135.975 68.6103 138.7 72.529Z" fill="#905224"/>
      <path d="M144.767 86.5509C147.301 89.2842 133.603 99.6903 130.878 95.7716C128.153 91.8529 141.135 82.6335 144.767 86.5509Z" fill="#905224"/>
      <path d="M150.072 100.573C151.728 103.593 138.908 114.015 135.729 109.041C132.549 104.067 148.254 97.2569 150.072 100.573Z" fill="#905224"/>
      <path d="M149.191 115.208C151.414 118.272 142.102 125.023 139.831 121.707C137.561 118.391 147.223 112.495 149.191 115.208Z" fill="#905224"/>
      <path d="M114.543 86.8931C115.783 89.0763 104.888 98.6729 102.313 93.9995C99.7381 89.3266 112.574 83.4257 114.543 86.8931Z" fill="#905224"/>
      <path d="M124.845 101.211C127.277 104.206 112.17 113.9 109.898 110.131C107.627 106.363 121.667 97.2925 124.845 101.211Z" fill="#905224"/>
      <path d="M129.842 113.725C131.102 116.137 117.017 127.32 114.139 122.194C111.262 117.069 127.722 109.655 129.842 113.725Z" fill="#905224"/>
      <path d="M133.185 126.695C135.961 129.305 121.566 138.477 119.446 134.406C117.325 130.336 130.462 124.133 133.185 126.695Z" fill="#905224"/>
      <path d="M136.825 138.457C138.405 140.479 127.169 149.18 124.596 146.167C122.023 143.153 133.647 134.388 136.825 138.457Z" fill="#905224"/>
      <path d="M118.713 152.36C120.157 154.475 107.548 164.142 104.975 160.675C102.401 157.209 116.14 148.592 118.713 152.36Z" fill="#905224"/>
      <path d="M113.105 139.997C114.439 142.032 99.2213 153.291 96.9499 149.824C94.679 146.358 110.833 136.53 113.105 139.997Z" fill="#905224"/>
      <path d="M105.082 128.995C106.361 131.539 94.6723 140.776 92.098 136.706C89.5241 132.636 103.567 125.98 105.082 128.995Z" fill="#905224"/>
      <path d="M100.838 116.329C102.575 118.823 88.3136 128.565 85.7392 124.495C83.1653 120.426 98.1133 112.41 100.838 116.329Z" fill="#905224"/>
      <path d="M93.2603 101.856C95.2705 104.159 80.2822 114.244 78.161 109.872C76.0397 105.5 90.2337 98.3908 93.2603 101.856Z" fill="#905224"/>
      <path d="M68.7917 108.074C70.684 110.45 57.4756 120.158 55.2038 116.389C52.9325 112.621 65.3108 103.704 68.7917 108.074Z" fill="#905224"/>
      <path d="M75.1591 124.207C77.2502 126.984 62.9343 134.784 61.2666 130.713C59.5993 126.642 72.8888 121.193 75.1591 124.207Z" fill="#905224"/>
      <path d="M82.4305 138.982C84.489 141.996 70.2062 149.86 68.2374 146.695C66.2691 143.529 79.857 135.214 82.4305 138.982Z" fill="#905224"/>
      <path d="M89.1 151.796C90.657 154.382 76.4215 162.222 74.3009 158.302C72.1803 154.383 86.8287 148.027 89.1 151.796Z" fill="#905224"/>
      <path d="M93.651 164.009C94.9146 165.936 81.4258 174.284 79.91 170.665C78.3941 167.047 91.3801 160.543 93.651 164.009Z" fill="#905224"/>
      <path d="M68.2584 164.798C69.6685 166.724 60.5632 172.803 59.048 169.637C57.5328 166.471 65.8364 161.482 68.2584 164.798Z" fill="#905224"/>
      <path d="M61.2949 153.794C63.0073 155.8 48.7685 164.824 46.9503 161.055C45.1321 157.286 58.7224 150.78 61.2949 153.794Z" fill="#905224"/>
      <path d="M56.8973 139.016C58.9123 141.648 44.8257 151.402 42.2497 146.126C39.6741 140.849 54.4754 135.851 56.8973 139.016Z" fill="#905224"/>
      <path d="M37.8761 153.976C39.9193 156.324 32.4458 160.923 30.478 158.512C28.5107 156.101 35.9085 151.716 37.8761 153.976Z" fill="#905224"/>
      <path d="M31.5071 140.558C32.563 142.655 23.663 150.375 21.5419 146.154C19.4209 141.932 29.689 136.94 31.5071 140.558Z" fill="#905224"/>
      <path d="M49.6246 124.543C51.5911 126.396 38.1575 136.929 35.4316 132.407C32.7058 127.885 46.7498 121.832 49.6246 124.543Z" fill="#905224"/>
      <path d="M45.229 113.838C46.479 116.116 33.3073 125.018 31.6399 121.248C29.973 117.479 43.4114 110.522 45.229 113.838Z" fill="#905224"/>
      <path d="M24.3923 127.745C26.0436 129.97 14.5841 137.564 13.5208 133.492C12.4579 129.42 21.8192 124.279 24.3923 127.745Z" fill="#905224"/>
      <path d="M30.1445 97.3632C32.0577 97.995 26.9033 85.2989 26.9033 85.2989C26.9033 85.2989 20.4483 81.6869 16.4173 79.2786C12.3863 76.8703 3.51052 70.8478 1.89982 70.4469C0.289118 70.0459 4.73811 84.923 9.17951 90.5507C13.6209 96.1784 28.9352 96.9641 30.1445 97.3632Z" fill="#003125"/>
      <path d="M56.3102 78.2211C56.9597 76.4853 59.528 76.4065 62.752 75.5985C65.976 74.7904 68.1822 72.1734 69.7982 72.975C71.4142 73.7767 71.4167 75.5845 69.0009 76.9973C66.5852 78.4101 62.3517 80.0258 65.5795 82.0321C68.8073 84.0385 78.8868 89.8589 78.9062 104.341C78.9256 118.824 66.5744 133.883 63.0307 132.12C61.8211 131.519 63.0111 117.435 63.6039 108.786C64.1967 100.137 63.5716 88.2696 60.7479 84.6527C57.9241 81.0359 55.708 79.8294 56.3102 78.2211Z" fill="#003125"/>
    </svg>
  `
  node?.appendChild(newDiv);
}

document.addEventListener('bundly:afterLoadBundle', ({ target }) => {
  addBasket({ node: target.parentNode });
});

document.addEventListener('bundly:afterUpdateBlock', ({ target }) => {
  const node = target.querySelector('.bundly__content');

  addBasket({ node });
});
